import { useEffect } from 'react';

export function useStructuredData(schema: Record<string, unknown>, id: string): void {
  useEffect(() => {
    if (document.getElementById(id)) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);
}
